export default function clearfix() {
  const element = document.createElement('span');
  element.classList.add('clearfix');
  return element;
}
